const messages = {
    "it": {
        "menu": {
            "delete": "Eliminando il menù le eventuali sessioni aperte non saranno in grado di concludere i loro ordini, proseguire comunque?"
        },
        "tavolo": {
            "delete": "Eliminando il tavolo gli utenti non potranno concludere gli ordini iniziati su di esso, proseguire comunque?"
        },
        "listino": {
            "delete": "Confermi l'eliminazione del listino?"
        },
        "gruppo": {
            "delete": "Confermi l'eliminazione del gruppo?"
        },
        "allergeni": {
            "celery_amber": "Può contenere sedano",
            "celery_grey": "Non contiene sedano",
            "celery_red": "Contiene sedano",
            "crustacens_amber": "Può contenere crostacei",
            "crustacens_grey": "Non contiene crostacei",
            "crustacens_red": "Contiene crostacei",
            "eggs_amber": "Può contenere uova",
            "eggs_grey": "Non contiene uova",
            "eggs_red": "Contiene uova",
            "fish_amber": "Può contenere pesce",
            "fish_grey": "Non contiene pesce",
            "fish_red": "Contiene pesce",
            "lupin_amber": "Può contenere lupino",
            "lupin_grey": "Non contiene lupino",
            "lupin_red": "Contiene lupino",
            "milk_amber": "Può contenere latte",
            "milk_grey": "Non contiene latte",
            "milk_red": "Contiene latte",
            "molluscs_amber": "Può contenere molluschi",
            "molluscs_grey": "Non contiene molluschi",
            "molluscs_red": "Contiene molluschi",
            "mustard_amber": "Può contenere senape",
            "mustard_grey": "Non contiene senape",
            "mustard_red": "Contiene senape",
            "peanut_amber": "Può contenere arachide",
            "peanut_grey": "Non contiene arachide",
            "peanut_red": "Contiene arachide",
            "sesame_amber": "Può contenere sesamo",
            "sesame_grey": "Non contiene sesamo",
            "sesame_red": "Contiene sesamo",
            "soya_amber": "Può contenere soia",
            "soya_grey": "Non contiene soia",
            "soya_red": "Contiene soia",
            "sulphurdioxide_amber": "Può contenere diossido di zolfo",
            "sulphurdioxide_grey": "Non contiene diossido di zolfo",
            "sulphurdioxide_red": "Contiene diossido di zolfo",
            "treenut_amber": "Può contenere frutta a guscio",
            "treenut_grey": "Non contiene frutta a guscio",
            "treenut_red": "Contiene frutta a guscio",
            "wheat_amber": "Può contenere grano",
            "wheat_grey": "Non contiene grano",
            "wheat_red": "Contiene grano",
            "spices": "Contiene spezie"
        },
        "currency": {
            "style": "currency", "currency": "EUR",
        },
        "percent": {
            "style": "percent", 
        }
    }
}

module.exports = messages



// WEBPACK FOOTER //
// ./src/i18n.js